import React from 'react'
import ReactModal from 'react-modal'
import Media from 'react-media'
import styled from 'styled-components'
import noScroll from 'no-scroll'

import { filter } from 'styles/colors'

import { FormContainer } from 'components/form'
import XComponent from 'components/icons/X'

ReactModal.setAppElement('#root')

const X = styled(XComponent)`
  padding: 16px;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
`

class Modal extends React.Component {
  componentDidMount() {
    if (this.props.isOpen) {
      noScroll.on()
    }
  }

  componentWillUnmount() {
    noScroll.off()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.props.isOpen ? noScroll.on() : noScroll.off()
    }
  }

  render() {
    const {
      children,
      isOpen,
      onRequestClose,
      small,
      title,
      ...rest
    } = this.props

    if (!isOpen) return null

    return (
      <Media query="(min-width: 640px)">
        {matches => (
          <ReactModal
            style={{
              overlay: {
                backgroundColor: filter,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                overflow: 'auto',
              },
              content: {
                backgroundColor: 'transparent',
                position: 'relative',
                top: 'auto',
                right: 'auto',
                bottom: 'auto',
                left: 'auto',
                border: 'none',
                borderRadius: 0,
                margin: matches ? '60px 0 20px' : '20px 0',
                padding: 0,
                overflow: 'visible',
              },
            }}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
            onRequestClose={onRequestClose}
            isOpen={isOpen}
            {...rest}>
            <X
              onClick={onRequestClose}
              tabIndex="0"
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.preventDefault()
                  onRequestClose()
                }
              }}
            />
            <FormContainer
              loading={this.props.loading}
              small={small}
              title={title}>
              {children}
            </FormContainer>
          </ReactModal>
        )}
      </Media>
    )
  }
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/Modal.js